<template>
  <div>
    <!-- 基础信息 -->
    <baseBreadcrumb :page="$t('message.basicInformation')" :menu="$t('message.userInfo')"></baseBreadcrumb>
    <!-- 客户账号信息 -->
    <div class="body">
      <!-- 客户账号信息: -->
      <div class="head">
        {{ $t("message.customerAccountInformation") }}
        <div class="fr">
          <!-- 获取临时密码 -->
          <el-button type="text" @click="getClientTempPwd" v-if="isAuth(564)">
            {{ $t("message.getTemporaryPassword") }}
          </el-button>
          <!-- 修改名称 -->
          <el-button type="text" @click="modifyName" v-if="isAuth(565)">
            {{ $t("message.modifyName") }}
          </el-button>
          <!-- 密码重置 -->
          <el-button type="text" @click="resetPassword" v-if="isAuth(467)">
            {{ $t("message.passwordReset") }}
          </el-button>
          <!-- 修改 -->
          <el-button type="text" @click="edit" v-if="isAuth(468)">
            {{ $t("message.edit") }}
          </el-button>
        </div>
      </div>
      <div class="content">
        <div class="img">
          <img :src="detail.portrait_url" alt="" v-if="detail.portrait_url" />
          <img src="@/assets/user/user.svg" alt="" v-else />
        </div>
        <div class="item">
          <!--注册时间  -->
          <div class="row">
            <div class="key">{{ $t("message.registrationDate") }}：</div>
            <div class="val">{{ detail.created_at }}</div>
          </div>
          <!-- 上次访问时间： -->
          <div class="row">
            <div class="key">{{ $t("message.lastAccessTime") }}：</div>
            <div class="val">{{ detail.last_login_at }}</div>
          </div>
          <!-- 系统ID -->
          <div class="row">
            <div class="key">{{ $t("message.SystemID") }}：</div>
            <div class="val">{{ detail.id }}</div>
          </div>
          <!-- 自动添加Made in China -->
          <div class="row">
            <div class="key">{{ $t("message.autoAddMadeInChina") }}：</div>
            <div class="val"> <el-switch v-model="detail.allow_made_in" active-color="#B4272D"
                @change="setMadeInChinaSwitch" active-text="开通" inactive-text="关闭">
              </el-switch></div>
          </div>
          <!-- 需要自动抽查 -->
          <div class="row">
            <div class="key">{{ $t("message.requireAutoSpotCheck") }}：</div>
            <div class="val"> <el-switch v-model="detail.allow_spot_task" active-color="#B4272D"
                :disabled="!isAuth(482)" @change="setClientSpotTask" active-text="开通" inactive-text="关闭">
              </el-switch></div>
          </div>
        </div>
        <div class="item">
          <!--系统登录名  -->
          <div class="row">
            <div class="key">{{ $t("message.systemLoginName") }}：</div>
            <div class="val">{{ detail.username }}</div>
          </div>
          <!-- 全名(真名) -->
          <div class="row">
            <div class="key">{{ $t("message.fullName") }}：</div>
            <div class="val">{{ detail.realname }}</div>
          </div>
          <!-- 邮箱 -->
          <div class="row">
            <div class="key">{{ $t("message.email") }}：</div>
            <div class="val">{{ detail.email }}
              <p :style="{ color: detail.email_is_checked ? '#67C23A' : '#B4272D' }">{{ detail.email_is_checked ? '已认证'
                : '未认证'
              }}</p>
            </div>
          </div>
          <!-- 全名（罗马字） -->
          <div class="row">
            <div class="key">{{ $t("message.fullNameInRomanji") }}：</div>
            <div class="val">{{ detail.name_roma }} <!-- 编辑 -->
              <el-button type="text" @click="fullNameInRomanji" v-if="isAuth(635)">{{ $t('message.redact')
              }}</el-button>
            </div>
          </div>
        </div>
        <div class="item">
          <!--手机号  -->
          <div class="row">
            <div class="key">{{ $t("message.cellphoneNumber") }}：</div>
            <div class="val">{{ detail.mobile }}</div>
          </div>
          <!-- 电话号码 -->
          <div class="row">
            <div class="key">{{ $t("message.telephoneNumber") }}：</div>
            <div class="val">{{ detail.tel }}</div>
          </div>
          <!-- 账号类别 -->
          <div class="row">
            <div class="key">{{ $t("message.typeOfAccount") }}：</div>
            <div class="val">主账号</div>
          </div>
            <!-- 商品管理同步数据 -->
            <div class="row">
            <div class="key">{{ $t("message.productManagementSyncData") }}：</div>
            <div class="val">
              <el-switch
                v-model="syncEnabled"
                active-color="#B4272D"
                :disabled="syncSettingLoading"
                active-text="开启"
                inactive-text="关闭"
                @change="setSyncSetting"
              />
            </div>
          </div>
        </div>
        <div class="item">
          <!-- 账户状态  -->
          <div class="row">
            <div class="key">{{ $t("message.accountStatus") }}：</div>
            <div class="val">
              {{ detail.account_status }}
            </div>
          </div>
          <!-- 调查问卷  -->
          <div class="row">
            <div class="key">调查问卷：</div>
            <div class="val">
              <router-link :to="'/questionnaire?user_id=' + user_id" target="_blank">
                <el-button type="text">查看问卷</el-button>
              </router-link>
            </div>
          </div>
          <!-- 客户标记  -->
          <div class="row">
            <div class="key">客户标记：</div>
            <div class="val">
              <!-- 编辑 -->
              <el-button type="text" @click="$refs.customerMarking.dialogVisible = true">{{ $t('message.redact')
              }}</el-button>
            </div>
          </div>
          <!-- 小客户手续费 -->
          <div class="row">
            <div class="key">{{ $t("message.smallOrderMinFee") }}：</div>
            <div class="val">
              <el-switch v-model="detail.small_order_min_fee" active-color="#B4272D"
                @change="setSmallOrderMinFee" active-text="生效" inactive-text="不生效" :disabled="!isAuth(775)">
              </el-switch>
            </div>
          </div>
          <!-- 是否接收邮件  -->
          <div class="row">
            <div class="key">问题产品邮件：</div>
            <div class="val">
              <el-switch v-model="detail.block_problem_email" active-color="#B4272D"
                @change="switchClientProblemEmailBlock" active-text="接收" inactive-text="关闭">
              </el-switch>
            </div>
          </div>
        </div>

        <div class="img"></div>
      </div>
    </div>
    <!-- 会员等级: -->
    <div class="body">
      <!-- 会员等级:: -->
      <div class="head">
        {{ $t("message.membershipLevel") }}
      </div>
      <div class="content">
        <div class="img"></div>
        <div class="item">
          <!--客户等级  -->
          <div class="row">
            <div class="key">{{ $t("message.clientGrade") }}：</div>
            <div class="val">{{ detail.level_name }}</div>
          </div>
          <!-- 手续费比例 -->
          <div class="row">
            <div class="key">{{ $t("message.commissionRate") }}：</div>
            <div class="val">{{ (detail.service_rate * 100).toFixed(2) }}%</div>
          </div>
          <!-- 客户属性 -->
          <div class="row">
            <div class="key">{{ $t("message.customerProperty") }}：</div>
            <div class="val">
              {{ detail.is_vip === 1 ? $t('message.potentialCustomer') : $t('message.ordinaryCustomer') }}
              <!-- 修改 -->
              <el-button type="text" @click="clientAttributeEdit" v-if="isAuth(461)">【{{ $t("message.edit")
              }}】</el-button>
            </div>
          </div>
          <!-- 人工设置免手续费 -->
          <div class="row">
            <div class="key">{{ $t("message.manualSetupFreeOfCharge") }}：</div>
            <div class="val">
              <!-- 开通 -->
              <el-button type="text" @click="setClientFreeByDate" v-if="isAuth(494)">
                {{ $t("message.liberal") }}
              </el-button>
            </div>
          </div>
          <!-- 开始免手续费日期 -->
          <div class="row">
            <div class="key">{{ $t("message.startingFeeFreeDate") }}：</div>
            <div class="val">
              {{ detail.is_free_by_date ? detail.is_free_by_date.free_start : '' }}
            </div>
          </div>
          <!-- 结束免手续费日期 -->
          <div class="row">
            <div class="key">{{ $t("message.endOfFeeFreeDate") }}：</div>
            <div class="val">
              {{ detail.is_free_by_date ? detail.is_free_by_date.free_end : '' }}
            </div>
          </div>
          <!-- 讲师注册到期时间 -->
          <div class="row">
            <div class="key">{{ $t("message.lecturerRegistrationExpirationDate") }}：</div>
            <div class="val">
              {{ detail.lecturerRegistrationExpirationDate }}
            </div>
          </div>
        </div>
        <div class="item">
          <!--介绍讲师  -->
          <div class="row">
            <div class="key">{{ $t("message.introductionLecturer") }}：</div>
            <div class="val">{{ detail.gk_realname }}</div>
          </div>
          <!-- 人工设置优惠到期 -->
          <div class="row">
            <div class="key">{{ $t("message.newCustomerOfferExpires") }}：</div>
            <div class="val">{{ detail.discount_end_at }}</div>
          </div>
          <!-- 定额会员 -->
          <div class="row">
            <div class="key">{{ $t("message.quotaMember") }}：</div>
            <div class="val">
              {{ detail.is_pay_vip_now ? "是" : "否" }}
              <!-- 开通会员 -->
              <el-button type="text" @click="openMembership" v-if="isAuth(466)">【{{ $t("message.openMembership")
              }}】</el-button>
            </div>
          </div>
          <!-- 定时开通会员 -->
          <div class="row">
            <div class="key">{{ $t("message.timedMembershipActivation") }}：</div>
            <div class="val">
              <span v-if="detail.plan_vip_start_at">
                {{ detail.plan_vip_start_at }}
                <!-- 取消开通会员 -->
                <el-button type="text" @click="cancelPlan" v-if="isAuth(466)">
                  【{{ $t("message.cancelMembershipActivation") }}】
                </el-button>
              </span>
              <span v-else>
                <!-- 定时开通会员 -->
                <el-button type="text" @click="timedMembershipActivation" v-if="isAuth(466)">
                  【{{ $t("message.timedMembershipActivation") }}】
                </el-button>
              </span>
            </div>
          </div>
          <!-- 是否续费定额会员 -->
          <div class="row">
            <div class="key">{{ $t("message.whetherToRenewQuotaMembership") }}：</div>
            <div class="val">
              ({{ detail.pay_vip_continue }}天) <el-button type="text" @click="$refs.vipRenew.dialogVisible = true"
                v-if="isAuth(466)">{{
                  $t('message.Settings') }}</el-button>
            </div>
          </div>
          <!-- SVIP： -->
          <div class="row">
            <div class="key">SVIP：</div>
            <div class="val">
              {{ detail.is_svip ? "是" : "否" }}
              <el-button type="text" @click="is_Svip" v-if="isAuth(482) && !detail.is_svip">【{{
                $t("message.liberalSVIP")
              }}】</el-button>
            </div>
          </div>
          <!-- SVIP： -->
          <div class="row">
            <div class="key">是否续费SVIP：</div>
            <div class="val">
              <el-switch v-model="detail.is_svip_continue" active-color="#B4272D" :disabled="!isAuth(482)"
                @change="isSvipContinue" active-text="开通" inactive-text="关闭">
              </el-switch>
            </div>
          </div>
        </div>
        <div class="item">
          <!--会员到期日期  -->
          <div class="row">
            <div class="key">
              {{ $t("message.expirationDateOfMembership") }}：
            </div>
            <div class="val">
              {{ detail.pay_vip_end }}
              ({{ detail.pay_vip_end_days }}天)
            </div>
          </div>
          <!-- 当前账户余额(円) -->
          <div class="row">
            <div class="key">
              {{ $t("message.currentAccountBalance_yen") }}：
            </div>
            <div class="val">{{ detail.balance }}</div>
          </div>
          <!-- 累计商品金额(円) -->
          <div class="row">
            <div class="key">
              {{ $t("message.accumulatedValueOfTheProduct_yen") }}：
            </div>
            <div class="val">{{ detail.goods_amount }}</div>
          </div>
          <!-- 转寄会员   -->
          <div class="row">
            <div class="key">{{ $t("message.forwardToMembers") }}：</div>
            <div class="val">
              {{ detail.user_resend_vip != false ? "是" : "否" }}
              <!-- 开通会员 -->
              <el-button type="text" @click="openResend" v-if="isAuth(466)">【{{ $t("message.openMembership")
              }}】</el-button>
            </div>
          </div>
          <!-- 转寄月费到期日期 -->
          <div class="row">
            <div class="key">
              {{ $t("message.forwardingMonthlyFeeDueDate") }}：
            </div>
            <div class="val" v-if="detail.user_resend_vip && detail.user_resend_vip != false">
              {{ detail.user_resend_vip.free_end }}
              ({{ calculateDaysDifference(detail.user_resend_vip.free_end) }}天)
            </div>
            <div class="val" v-else>--</div>
          </div>
        </div>
        <div class="item">
          <!--授权欠费额度(円)  -->
          <div class="row">
            <div class="key">{{ $t("message.authorizeArrears_yen") }}：</div>
            <div class="val">
              {{ detail.credit }}
              <!-- 编辑 -->
              <el-button type="text" @click="authorizeArrears" v-if="isAuth(464)">【{{ $t("message.redact")
              }}】</el-button>
            </div>
          </div>
          <!--授权欠费时间 -->
          <!-- <div class="row">
            <div class="key">{{ $t("message.authorizeOverdueTime") }}：</div>
            <div class="val">暂无</div>
          </div> -->
          <!--授权欠费文件  -->
          <div class="row">
            <div class="key">
              {{ $t("message.authorizedArrearsDocument") }}：
            </div>
            <div class="val">
              {{ detail.credit_file }}
              <!-- 查看 -->
              <el-button type="text">【{{ $t("message.look") }}】</el-button>
            </div>
          </div>
          <!-- 客户注意事项 -->
          <div class="row">
            <div class="key">
              {{ $t("message.notesForCustomers") }}：
            </div>
            <div class="val">
              <el-input type="textarea" v-model="detail.y_remark" style="width: 145px; padding: 0;"
                @blur="updateYRemark"></el-input>
            </div>
          </div>
          <!-- 运营备注 -->
          <div class="row">
            <div class="key">
              {{ $t("message.userRamrk") }}：
            </div>
            <div class="val">
              <el-input type="textarea" v-model="detail.desc" style="width: 145px; padding: 0;" @blur="updateDesc"
                :disabled="!isAuth(558)"></el-input>
            </div>
          </div>
        </div>
        <div class="img"></div>
      </div>
    </div>
    <!-- 客户分配 授权状态 客户状态 发票相关信息:-->
    <div class="list">
      <!-- 客户分配 -->
      <div class="item">
        <div class="head">
          {{ $t("message.customerAllocation") }}
          <div class="fr">
            <el-button type="text" @click="customerAllocation" v-if="isAuth(443)">
              {{ $t("message.customerAllocation") }}</el-button>
          </div>
        </div>
        <!-- 部门 -->
        <div class="row">
          <div class="key">{{ $t("message.department") }}:</div>
          <div class="val">{{ detail.client_depart_class }}</div>
        </div>
        <!-- 业务员 -->
        <div class="row">
          <div class="key">{{ $t("message.salesman") }}:</div>
          <div class="val">{{ detail.y_realname }}</div>
        </div>
        <!-- 采购员 -->
        <div class="row">
          <div class="key">{{ $t("message.buyer") }}:</div>
          <div class="val">{{ detail.g_realname }}</div>
        </div>
        <!-- 配货员 -->
        <div class="row">
          <div class="key">{{ $t("message.distributionMember") }}:</div>
          <div class="val">{{ detail.p_realname }}</div>
        </div>
      </div>
      <!-- 授权状态: -->
      <div class="item">
        <div class="head">
          {{ $t("message.authorizationStatus") }}
          <!-- 授权设置 -->
          <div class="fr">
            <el-button type="text" @click="authorizationSettings" v-if="isAuth(462)">
              {{ $t("message.authorizationSettings") }}</el-button>
          </div>
        </div>
        <!-- 装箱授权 -->
        <div class="row">
          <div class="key">{{ $t("message.packingAuthorization") }}:</div>
          <div class="val">{{ detail.authorized ? $t("message.are") : $t("message.no") }}</div>
        </div>
        <!-- 入金授权 -->
        <div class="row">
          <div class="key">{{ $t("message.goldenAuthorization") }}:</div>
          <div class="val">{{ detail.is_pay_authorized ? $t("message.are") : $t("message.no") }}</div>
        </div>
        <!-- 默认收件地址 -->
        <div class="row">
          <!-- 默认进口商 -->
          <div class="val" style="text-align: center;"> <el-button type="primary" size="small"
              @click="setUserAddressData($t('message.defaultImporter'), 1)">{{
                $t("message.defaultImporter") }}</el-button></div>
          <!-- 默认收货地址 -->
          <div class="val" style="text-align: center;"><el-button type="primary" size="small"
              @click="setUserAddressData($t('message.defaultShippingAddress'), 2)">{{
                $t("message.defaultShippingAddress") }}</el-button>
          </div>
        </div>
        <!-- RAKUMART海外仓集运 -->
        <div class="row">
          <div class="key">{{ $t("message.rakumartOverseasWarehouseConsolidation") }}:</div>
          <div class="val end">{{ detail.is_overseas_warehouse ? $t("message.are") : $t("message.no") }}
            <!-- 授权设置 -->
            <el-button type="primary" size="mini" @click="$refs.overseasWarehouseConsolidation.dialogVisible = true"
              v-if="isAuth(650)">{{
                $t('message.authorizationSettings') }}</el-button>
          </div>
        </div>
        <!-- 自主集运 -->
        <div class="row">
          <div class="key">{{ $t("message.selfConsolidation") }}:</div>
          <div class="val end">{{ detail.is_co_authorized ? $t("message.are") : $t("message.no") }}
            <!-- 授权设置 -->
            <el-button type="primary" size="mini" @click="$refs.selfConsolidation.dialogVisible = true"
              v-if="isAuth(648)">{{
                $t('message.authorizationSettings') }}</el-button>
          </div>
        </div>
      </div>
      <!-- 客户状态: -->
      <div class="item">
        <div class="head">
          {{ $t("message.userStatus") }}
          <!-- 聊天工具设置 -->
          <div class="fr">
            <el-button type="text" @click="chatSettings" v-if="isAuth(463)">
              {{ $t("message.chatSettings") }}</el-button>
          </div>
        </div>
        <!-- 客户标签 -->
        <div class="row">
          <div class="key">{{ $t("message.customerLabel") }}:</div>
          <div class="val">暂无</div>
        </div>
        <!-- 聊天工具 -->
        <div class="row">
          <div class="key">{{ $t("message.chatTools") }}</div>
          <div class="val">
            <img src="@/assets/user/CW.svg" alt="" v-if="detail.chatwork" />
            <img src="@/assets/user/raku.svg" alt="" v-else />
          </div>
        </div>
        <!-- 最新下单时间 -->
        <div class="row">
          <div class="key">{{ $t("message.latestOrderTime") }}:</div>
          <div class="val">{{ detail.lastOrderAt }}</div>
        </div>
      </div>
      <!-- 发票相关信息: -->
      <div class="item">
        <div class="head">
          {{ $t("message.invoiceRelatedInformation") }}
        </div>
        <!-- 发票包含其他金额 -->
        <div class="row">
          <div class="key">{{ $t("message.theInvoiceIncludesOtherAmounts") }}:</div>
          <div class="val">
            <el-switch v-model="detail.invoice_has_amount" active-color="#B4272D" @change="invoiceHasAmount"
              :disabled="!isAuth(599)">
            </el-switch>
          </div>
        </div>
        <!-- 发票比例 -->
        <div class="row">
          <div class="key">{{ $t("message.invoiceRatio") }}:</div>
          <div class="val">
            {{ detail.invoice_rate }} %
            <!-- 编辑 -->
            <el-button type="text" @click="invoiceEdit" v-if="isAuth(460)">【{{ $t("message.redact") }}】</el-button>
          </div>
        </div>
        <!-- 法人番号： -->
        <div class="row">
          <div class="key">法人番号:</div>
          <div class="val">
            {{ detail.tax_no }}
            <!-- 编辑 -->
            <el-button type="text" @click="editNoType('法人番号')">【{{ $t("message.redact") }}】</el-button>
          </div>
        </div>
        <!-- リアルタイム口座 -->
        <div class="row">
          <div class="key">リアルタイム口座:</div>
          <div class="val">
            {{ detail.bank_no }}
            <!-- 编辑 -->
            <el-button type="text" @click="editNoType('リアルタイム口座')">【{{ $t("message.redact") }}】</el-button>
          </div>
        </div>
        <!-- 標準コード -->
        <div class="row">
          <div class="key">標準コード:</div>
          <div class="val">
            {{ detail.standard_no }}
            <!-- 编辑 -->
            <el-button type="text" @click="editNoType('標準コード')">【{{ $t("message.redact") }}】</el-button>
          </div>
        </div>
        <!-- 客户售卖平台 -->
        <div class="row">
          <div class="key">{{ $t("message.customerSalesPlatform") }}:</div>
          <div class="val">
            <!-- 编辑 -->
            <el-button type="text" @click="customerSalesPlatform" v-if="isAuth(465)">【{{ $t("message.redact")
            }}】</el-button>
          </div>
        </div>
        <!-- 店铺信息 -->
        <div class="row" v-for="(item, index) in detail.userShop" :key="index">
          <div class="key">{{ item.shop_type }}:</div>
          <div class="val">
            <img :src="item.shop_screen" alt="" />
          </div>
        </div>
        <!-- 其他备注 -->
        <div class="row">
          <div class="key" style="align-items: self-start">{{ $t("message.otherRemarks") }}:</div>
          <div class="val">
            <el-input type="textarea" v-model="detail.invoice_remark" @blur="updateInvoiceRemark"></el-input>
          </div>
        </div>
      </div>
    </div>
    <!-- 注意事项 -->
    <announcements />
    <!-- 发票比例设置 -->
    <invoice ref="invoice" :detail="datas" />
    <!-- 客户 分配-->
    <allocation ref="allocation" :detail="datas" />
    <!-- 客户属性 -->
    <clientAttribute ref="clientAttribute" :detail="datas" />
    <!-- 开通付费会员 -->
    <openVIP ref="openVIP" />
    <!-- 开通转寄会员 -->
    <resendVIP ref="resendVIP" />
    <!-- 设置聊天 -->
    <chat ref="chat" :detail="datas" />
    <!-- 授权 -->
    <authorization ref="authorization" :detail="datas" />
    <!--授权欠费额度设置  -->
    <authorizedArrears ref="authorizedArrears" :detail="datas" />
    <!--客户售卖平台设置  -->
    <salesPlatform ref="salesPlatform" :detail="datas" />
    <!--基础信息修改 -->
    <editInformation ref="editInformation" :detail="datas" />
    <!-- 编辑默认地址 -->
    <editNo ref="editNo" :detail="datas" />
    <!-- 定额会员自动续费 -->
    <vipRenew ref="vipRenew" :detail="datas" />
    <!-- 默认地址查看 -->
    <defaultAddress ref="defaultAddress"
      :detail="userAddressData.type == 1 ? userAddressData.default_importer : userAddressData.default_receiver"
      :title="userAddressData.title" />
    <!--定时 开通付费会员 -->
    <timedActivationVIP ref="timedActivationVIP" />
    <!-- 客户标签 -->
    <customerMarking ref="customerMarking" />
    <!-- 修改名称 -->
    <modifyName ref="modifyName" :detail="datas" />
    <!-- 修改客户名罗马字 -->
    <fullNameInRomanji ref="fullNameInRomanji" :detail="datas" />
    <!-- 自住集运设置 -->
    <selfConsolidation ref="selfConsolidation" :detail="detail" />
    <!-- 海外仓设置 -->
    <overseasWarehouseConsolidation ref="overseasWarehouseConsolidation" :detail="detail" />
  </div>
</template>

<script>
import announcements from "./conponents/announcements";
import invoice from "./conponents/invoice";
import allocation from "./conponents/allocation";
import clientAttribute from "./conponents/clientAttribute";
import openVIP from "./conponents/openVIP";
import chat from "./conponents/chat";
import authorization from "./conponents/authorization";
import authorizedArrears from "./conponents/authorizedArrears";
import salesPlatform from "./conponents/salesPlatform";
import editInformation from "./conponents/editInformation";
import editNo from "./conponents/editNo";
import vipRenew from './conponents/vipRenew'
import defaultAddress from './conponents/defaultAddress'
import timedActivationVIP from './conponents/timedActivationVIP'
import customerMarking from './conponents/customerMarking'
import modifyName from './conponents/modifyName'
import resendVIP from "./conponents/resendVIP";
import fullNameInRomanji from './conponents/fullNameInRomanji'
import selfConsolidation from './conponents/selfConsolidation'
import overseasWarehouseConsolidation from './conponents/overseasWarehouseConsolidation'
import { oneMoreMonth } from '@/utlis/date'
export default {
  data() {
    return {
      datas: {},
      detail: {},
      user_id: this.$route.query.userID,
      syncEnabled: false,
      syncSettingLoading: false,
      show: false,
      adminID: JSON.parse(localStorage.getItem('japanUserRoleInfo')).id,
      userAddressData: { default_importer: {}, default_receiver: {}, title: '', type: 1 },
    };
  },
  components: {
    invoice,
    allocation,
    clientAttribute,
    openVIP,
    chat,
    authorization,
    authorizedArrears,
    salesPlatform,
    editInformation,
    editNo,
    announcements,
    vipRenew,
    defaultAddress,
    timedActivationVIP,
    customerMarking,
    modifyName,
    resendVIP,
    fullNameInRomanji,
    selfConsolidation,
    overseasWarehouseConsolidation
  },
  created() {
    this.clientDetail();
    this.userAddressList()
    this.syncSettingGet()

  },
  methods: {
    syncSettingGet() {
      this.$api.productManagementApi.syncSettingGet({
        user_id: Number(this.user_id)
      }).then(res => {
        this.syncEnabled = res.data.is_enabled == 1
      })
    },
    setSyncSetting(value) {
      this.syncSettingLoading = true
      this.$api.productManagementApi.syncSettingSet({
        user_id: Number(this.user_id),
        is_enabled: value ? 1 : 0
      }).then(res => {
        this.$message.success(res.msg)
      }).catch(() => {
        this.syncEnabled = !value
      }).finally(() => {
        this.syncSettingLoading = false
      })
    },
    userAddressList() {
      this.$api.clienteleApi.userAddressList({ user_id: this.user_id }).then(res => {
        res.data.forEach(item => {
          if (item.default_importer) {
            this.userAddressData.default_importer = item
          }
          if (item.default_receiver) {
            this.userAddressData.default_receiver = item
          }
        })
        console.log(this.userAddressData);
      })
    },
    clientDetail() {
      this.$api.clienteleApi
        .clientDetail({ user_id: this.user_id })
        .then((res) => {
          res.data.block_problem_email = res.data.block_problem_email == 1 ? false : true
          res.data.invoice_has_amount = res.data.invoice_has_amount == 1 ? true : false
          res.data.allow_spot_task = res.data.allow_spot_task == 1 ? true : false
          res.data.allow_made_in = res.data.allow_made_in == 1 ? true : false
          res.data.small_order_min_fee = res.data.small_order_min_fee == 1 ? true : false
          res.data.is_svip_continue =
            res.data.is_svip_continue == 1 ? true : false;
          this.detail = res.data;
          this.detail.editNoType = "";
          if (this.detail.gk_realname) {
            this.detail.lecturerRegistrationExpirationDate = oneMoreMonth(this.detail.created_at)
          }
          console.log(res);
        });
    },
    //发票比例设置
    invoiceEdit() {
      this.datas = JSON.parse(JSON.stringify(this.detail));
      this.$refs.invoice.dialogVisible = true;
    },
    // 客户 分配
    customerAllocation() {
      this.datas = JSON.parse(JSON.stringify(this.detail));
      this.$refs.allocation.dialogVisible = true;
    },
    //客户属性
    clientAttributeEdit() {
      this.datas = JSON.parse(JSON.stringify(this.detail));
      this.$refs.clientAttribute.dialogVisible = true;
    },
    // 开通会员
    openMembership() {
      this.datas = JSON.parse(JSON.stringify(this.detail));
      this.$refs.openVIP.dialogVisible = true;
    },
    // 聊天工具设置：
    chatSettings() {
      this.detail.chat = this.detail.chatwork ? 2 : 1;
      this.datas = JSON.parse(JSON.stringify(this.detail));
      this.$refs.chat.dialogVisible = true;
    },
    //授权设置
    authorizationSettings() {
      this.detail.authorizedChek = this.detail.authorized ? true : false;
      this.detail.is_pay_authorizedChek = this.detail.is_pay_authorized
        ? true
        : false;
      this.datas = JSON.parse(JSON.stringify(this.detail));
      this.$refs.authorization.dialogVisible = true;
    },
    //授权欠费额度(円)
    authorizeArrears() {
      this.datas = JSON.parse(JSON.stringify(this.detail));
      this.$refs.authorizedArrears.dialogVisible = true;
    },
    //客户售卖平台设置
    customerSalesPlatform() {
      this.datas = JSON.parse(JSON.stringify(this.detail));
      this.$refs.salesPlatform.dialogVisible = true;
    },
    //密码重置
    resetPassword() {
      this.$confirm("是否确认密码重置", this.$t("message.prompt"), {
        confirmButtonText: this.$t("message.ok"), //确定
        cancelButtonText: this.$t("message.cancel"), //取消
        type: "warning",
        center: true,
      })
        .then(() => {
          let datas = {
            user_id: this.$route.query.userID,
          };
          this.$api.clienteleApi.resetPassword(datas).then((res) => {
            this.$message.success(res.msg);
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消操作",
          });
        });
    },
    //基础信息修改
    edit() {
      this.datas = JSON.parse(JSON.stringify(this.detail));
      this.$refs.editInformation.dialogVisible = true;
    },
    //修改名称
    modifyName() {
      this.datas = JSON.parse(JSON.stringify(this.detail));
      this.$refs.modifyName.dialogVisible = true;
    },
    //获取临时
    getClientTempPwd() {
      this.$api.clienteleApi
        .getClientTempPwd({ user_id: this.user_id })
        .then((res) => {
          this.copy(res.data.tmpPwd)
        });
    },
    // 开通关闭SVIP
    is_Svip() {
      this.$confirm("是否给此用户开通SVIP?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
      })
        .then(() => {
          this.$api.clienteleApi
            .setClientSVIP({ user_id: this.user_id })
            .then((res) => {
              this.$message.success(res.msg);
              this.clientDetail();
            });
        })
        .catch(() => { });
    },
    //是否续费SVIP
    isSvipContinue() {
      this.$confirm(
        this.detail.is_svip_continue
          ? "是否给此用户续费SVIP?"
          : "是否关闭此用户续费SVIP?",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
          center: true,
        }
      )
        .then(() => {
          this.$api.clienteleApi
            .swithClientSvipContinue({ user_id: this.user_id })
            .then((res) => {
              this.$message.success(res.msg);
            });
        })
        .catch(() => {
          this.detail.is_svip_continue = !this.detail.is_svip_continue;
        });
    },
    // 修改地址
    editNoType(type) {
      this.datas = JSON.parse(JSON.stringify(this.detail));
      this.datas.editNoType = type;
      this.$refs.editNo.dialogVisible = true;
      this.$forceUpdate();
    },
    // 修改业务对客户的备注
    updateYRemark() {
      let datas = {
        user_id: this.user_id,
        y_remark: this.detail.y_remark
      }
      this.$api.clienteleApi.updateYRemark(datas).then(res => {
        this.$message.success(res.msg)
      })
    },
    //开通
    setClientFreeByDate() {
      let datas = {
        user_id: this.user_id,
      }
      this.$confirm("是否给此用户开通免手续费一个月服务?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
      })
        .then(() => {
          this.$api.clienteleApi.setClientFreeByDate(datas).then(res => {
            this.$message.success(res.msg)
            this.clientDetail()
          })
        })
        .catch(() => { });


    },
    //默认地址
    setUserAddressData(title, type) {
      this.userAddressData.title = title
      this.userAddressData.type = type
      this.$refs.defaultAddress.dialogVisible = true
    },
    // 定时开通会员
    timedMembershipActivation() {
      this.datas = JSON.parse(JSON.stringify(this.detail));
      this.$refs.timedActivationVIP.dialogVisible = true;

    },
    //切换问题产品邮件开关
    switchClientProblemEmailBlock() {
      this.$api.clienteleApi.switchClientProblemEmailBlock({ user_id: this.user_id }).then(res => {
        this.$message.success(res.msg)
      })
    },
    //修改客户备注
    updateDesc() {
      let datas = {
        user_id_set: [this.user_id],
        desc: this.detail.desc
      }
      this.$api.clienteleApi.updateDesc(datas).then(res => {
        this.$message.success(res.msg)
      })
    },
    //设置发票的额外备注
    updateInvoiceRemark() {
      let datas = {
        user_id: this.user_id,
        invoice_remark: this.detail.invoice_remark
      }
      this.$api.clienteleApi.updateInvoiceRemark(datas).then(res => {
        this.$message.success(res.msg)
      })
    },
    //取消定时VIP开通计划
    cancelPlan() {
      this.$confirm(
        "是否取消开通定时开通会员？",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
          center: true,
        }
      )
        .then(() => {
          this.$api.clienteleApi
            .cancelPlan({ user_id: this.user_id })
            .then((res) => {
              this.$message.success(res.msg);
              this.clientDetail();
            });
        })
        .catch(() => {

        });
    },
    //客户-详情-发票是否包含其他金额设置
    invoiceHasAmount() {
      let datas = {
        user_id: this.user_id,
        invoice_has_amount: this.detail.invoice_has_amount ? 1 : 0
      }
      this.$api.clienteleApi.invoiceHasAmount(datas).then(res => {
        this.$message.success(res.msg)
      })
    },
    //开通转寄
    openResend() {
      this.datas = JSON.parse(JSON.stringify(this.detail));
      this.$refs.resendVIP.dialogVisible = true;
    },
    //修改客户名罗马字
    fullNameInRomanji() {
      this.datas = JSON.parse(JSON.stringify(this.detail));
      this.$refs.fullNameInRomanji.dialogVisible = true;
    },
    // 转寄月费到期日期
    calculateDaysDifference(targetDate) {
      const today = new Date(); // 获取今天的日期
      const target = new Date(targetDate); // 转换目标日期为 Date 对象
      // 将时间部分清零，只计算日期差
      today.setHours(0, 0, 0, 0);
      target.setHours(0, 0, 0, 0);
      // 算相差的毫秒数
      const differenceInTime = target - today;
      // 转换为天数
      const differenceInDays = differenceInTime / (1000 * 60 * 60 * 24);
      return differenceInDays;
    },
    //客户-详情-是否允许添加made in china
    setMadeInChinaSwitch() {
      let datas = {
        user_id: this.user_id,
        allow_made_in: this.detail.allow_made_in ? 1 : 0
      }
      this.$api.clienteleApi.setMadeInChinaSwitch(datas).then(res => {
        this.$message.success(res.msg)
      })
    },
    //客户-详情-是否允许生成抽查任务
    setClientSpotTask() {
      let datas = {
        user_id: this.user_id,
        allow_spot_task: this.detail.allow_spot_task ? 1 : 0
      }
      this.$api.clienteleApi.setClientSpotTask(datas).then(res => {
        this.$message.success(res.msg)
      })
    },
    // 客户-详情-小客户手续费开关
    setSmallOrderMinFee() {
      this.$api.clienteleApi.setSmallOrderMinFee({
        user_id: this.user_id,
        small_order_min_fee: this.detail.small_order_min_fee ? 1 : 0
      }).then(res => {
        this.$message.success(res.msg)
      })
    },

  },
};
</script>

<style lang="scss" scoped>
.body {
  margin-bottom: 24px;

  .head {
    line-height: 40px;
    margin-bottom: 24px;
    font-size: 16px;

    font-weight: bold;
    color: #333333;

    .el-button {
      color: #2c96e7;
    }
  }

  .content {
    display: flex;

    .img {
      flex: 0.3;

      img {
        height: 80px;
        width: 80px;
        border-radius: 50%;
      }
    }

    .item {
      flex: 1;
      margin-right: 40px;

      .row {
        display: flex;
        margin-bottom: 10px;

        .key {
          flex: 1;
          text-align: right;
          margin-right: 10px;
        }

        .val {
          flex: 1;
        }


      }
    }
  }
}

.list {
  display: flex;

  .item {
    flex: 1;
    padding: 24px;
    background: #f8f8f8;
    border-radius: 8px;
    margin-right: 24px;

    &:nth-last-child(1) {
      margin: 0;
    }

    .head {
      line-height: 40px;
      margin-bottom: 24px;
      font-size: 16px;
      font-weight: bold;
      color: #333333;

      .el-button {
        color: #2c96e7;
      }
    }

    .row {
      display: flex;
      margin-bottom: 10px;

      .key {
        flex: 1.2;
        text-align: right;
        margin-right: 10px;
        display: flex;
        align-items: center;
        justify-content: flex-end;
      }

      .val {
        flex: 4;

        img {
          height: 40px;
          width: 40px;
        }
      }

      .end {
        display: flex;
        justify-content: space-between;
        line-height: 28px;
      }
    }

    &:nth-last-child(2) {
      .key {
        flex: 2;
      }
    }

    &:nth-last-child(1) {
      .val {
        img {
          width: 60px;
          height: 60px;
          background: #ffffff;
          border: 1px solid #dcdfe6;
          border-radius: 4px;
        }
      }

      .key {
        flex: 3;
      }
    }
  }
}

/deep/.el-button--text {
  padding: 0;
}

/deep/.el-textarea__inner {
  width: 180px;
  padding: 0;
  height: 100px;
}
</style>
